import dayjs from 'dayjs';

export const currentYear = dayjs().year();

export const yearOptions = [];

for (let year = currentYear; year >= 2024; year--) {
  yearOptions.push({
    label: year.toString(),
    value: year,
  });
}

export const monthOptions = [
  { label: 'All Month', value: '0' },
  { label: 'January', value: '1' },
  { label: 'February', value: '2' },
  { label: 'March', value: '3' },
  { label: 'April', value: '4' },
  { label: 'May', value: '5' },
  { label: 'June', value: '6' },
  { label: 'July', value: '7' },
  { label: 'August', value: '8' },
  { label: 'September', value: '9' },
  { label: 'October', value: '10' },
  { label: 'November', value: '11' },
  { label: 'December', value: '12' },
];

export const FilterLeaderboardType = {
  CURRENT: 'current',
  HISTORY: 'history',
};
export const FilterLeaderboardTypeLabel = {
  [FilterLeaderboardType.CURRENT]: 'CURRENT',
  [FilterLeaderboardType.HISTORY]: 'HISTORY',
};

export const FilterPointManagementType = {
  DAILY: 'daily',
  MONTHLY: 'monthly',
};

export const FilterPointManagementTypeLabel = {
  [FilterPointManagementType.DAILY]: 'Daily',
  [FilterPointManagementType.MONTHLY]: 'Monthly',
};

export const SocialNameList = {
  EMAIL: 'email',
  GOOGLE: 'google',
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
};

export const UsernameList = {
  SYNCED: 'Synced',
  UNSYNCED: 'Unsynced',
};

export const UrlStatus = {
  SUCCESSED: 'successed',
  FAIlURED: 'failured',
};
